import React from 'react';
import * as styles from './GroupIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import groupIcon from '../icons/prefilled/16x16/group.svg';

type SVGIconProps = Omit<React.ComponentProps<typeof SVGIcon>, 'children'>;

type GroupIconProps = SVGIconProps;

const GroupIcon = (props: GroupIconProps) => {
  return (
    <div className={styles.container}>
      <SVGIcon {...props}>{groupIcon}</SVGIcon>
    </div>
  );
};

export default GroupIcon;
